import { parseSanitizedHtml } from "@/utils/sanitizeHtml";
import Position from './Position';
import { useCallback, useEffect, useMemo } from "react";
import Helpers from "@/Helpers";

export default function PositionInventory(props) {
   const {sectionData,values,setValue} = props;
   const currentSection = sectionData?.currentSection;
   const isRenderable = !!sectionData && !!currentSection && currentSection.formId === 1800;

    const content = Helpers.getSectionContent(currentSection, sectionData?.lang);
   const elements = Helpers.getSectionElements(content);
   const items = useMemo(() => (Array.isArray(elements?.items) ? elements.items : []), [elements]);
   const instructionsHtml = Helpers.getSectionHtmlValue(content, "instructions");

   const onChange = useCallback(async (childId, value) => {
      if (!currentSection?.formId) return;
      const id = currentSection.formId + childId;
      if(id in values && values[id]===value)
         setValue(childId,"");
      else
         setValue( childId, value);
   }, [currentSection?.formId, setValue, values]);

   useEffect(() => {
      if (!isRenderable || typeof sectionData?.registerSection !== "function") return;
      sectionData.registerSection( 400, items.length);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [isRenderable, items.length]);

   useEffect(() => {
      if (!isRenderable || !sectionData?.isAdmin || !currentSection?.formId) return;

      const handleKeyDown = (e) => {
         const activeTag = document.activeElement?.tagName?.toLowerCase();
         if (activeTag === "input" || activeTag === "textarea" || activeTag === "select") return;

         const key = e.key;
         if (!/[1-3]/.test(key)) return;

         const selectedValue = Number(key);
         const nextUnanswered = items.find((item) => {
            const currentValue = values?.[currentSection.formId + item.id];
            return (
               currentValue === undefined ||
               currentValue === null ||
               currentValue === "" ||
               currentValue === 0 ||
               currentValue === "0"
            );
         });

         if (!nextUnanswered) return;

         const itemOptions = Array.isArray(nextUnanswered?.options) ? nextUnanswered.options : [];
         const matchingOption =
            itemOptions.find((option) => Number(option?.value) === selectedValue) ||
            itemOptions[selectedValue - 1] ||
            null;
         const optionValue = Number(matchingOption?.value || selectedValue);
         if (!Number.isFinite(optionValue) || optionValue <= 0) return;

         e.preventDefault();
         void onChange(nextUnanswered.id, optionValue);
      };

      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
   }, [isRenderable, sectionData?.isAdmin, items, values, currentSection?.formId, onChange]);

   if (!isRenderable) return null;

   return (
      <>
         <div className="instructions left">
            {parseSanitizedHtml(instructionsHtml)}
         </div>
         <div className="content center">
            {items.map((item, i) => {
               return (
                  <Position 
                     key={item.id || i}
                     item={item}
                     setValue={onChange} 
                     values={values} 
                     sectionData={sectionData}
                  />
               );
            })}
         </div>
      </>
   );
}


